import { useEffect, useState } from "react"
import { usePath } from "../libs/path/PathProvider"
import { FMFile } from "../shared/FMFile"
import Loading from "../libs/loading/Loading"
import FileList from "../components/FileList"
import Files from "../fmanlibs/Files"
import DragAndDrop, { IUpload } from "../libs/dragdrop/DragAndDrop"
import { useSnackbar } from "../libs/dialog/SnackbarProvider"
import Dirs from "../fmanlibs/Dirs"
import { useDialog } from "../libs/dialog/DialogProvider"
import UploadDlg from "../dialogs/UploadDlg"

const MAX_FILE_SIZE = 100_000_000

export default function Main(){
    const [root,setRoot] = useState<FMFile|undefined>()
    const [files,setFiles] = useState<FMFile[]|undefined>()
    const [busy,setBusy] = useState<boolean>(false)
    const {path} = usePath()
    const {setSnackbar} = useSnackbar()
    const {openDialog} = useDialog()

    const getRootId = () => path.split("/")[1] || "0"
    const loadFiles = async (id:string) => {
        const file = await Files.i.get(id)
        setRoot(file)
        setFiles(await Files.i.getBatch(file.childIds||[]))
    }
    const onRefresh = (id:string,file:FMFile) => id==getRootId() && loadFiles(id)
    useEffect(() => {
        setFiles(undefined)
        loadFiles(getRootId())
        Files.i.on("update", onRefresh)
        return () => { Files.i.removeListener("update", onRefresh)}
    }, [path])

    const onEnter = (e:any) => {}
    const onLeave = (e:any) => {}
    const onDrop = async (e:any) => {
        e.preventDefault()
        if (busy || !root) return
        else setBusy(true)

        let files: IUpload[];
        try { files = await DragAndDrop.getFiles(root._id, e) }
        catch(e){
            setSnackbar(e)
            return setBusy(false)
        }
        if (files.length==0) return

        const paths = Array.from(new Set(files.map(file => file.path))).sort((l,r) => l.length>r.length ? -1 : 1).filter(p => !!p)
        let didCreate = false
        for(let path of paths) try {
            if (!await Dirs.i.findPath(getRootId(), path)) {
                await Dirs.i.createPath(root._id, path)
                didCreate = true
            }            
        }catch(e){
            setSnackbar(e)
            return setBusy(false)
        }

        let parent:FMFile
        if (didCreate) {
            Dirs.i.expire().get()
            parent = await Files.i.expire(root._id).get(root._id)
        }
        else parent = root

        const toUpload = files.filter(file => file.file.size<=MAX_FILE_SIZE)
        if (toUpload.length) openDialog({id:"uploads", children:<UploadDlg root={root} files={toUpload}/>, canClose:()=>false, onClosed:()=>setBusy(false)})
    }
    const onOver = (e:any) => { e.preventDefault(); e.stopPropagation }

    return <div id="main" className="flex1" onDragEnter={onEnter} onDragLeave={onLeave} onDrop={onDrop} onDragOver={onOver}>
        {files ? <FileList files={files} key={root?._id}/> : <Loading className="large"/>}
    </div>
}